import { Injectable } from '@angular/core';
import { loadStripe, Stripe } from '@stripe/stripe-js';

import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StripeService {
  private stripe: Stripe | null | undefined;

  constructor() {}

  async init(): Promise<void> {
    this.stripe = await loadStripe(environment.stripePublishableKey);
  }

  getStripe(): Stripe | undefined {
    return this.stripe ?? undefined;
  }
}
